import { render } from "./ExtraQuestionInputBox.vue?vue&type=template&id=4ae69f28&scoped=true"
import script from "./ExtraQuestionInputBox.vue?vue&type=script&lang=js"
export * from "./ExtraQuestionInputBox.vue?vue&type=script&lang=js"

import "./ExtraQuestionInputBox.vue?vue&type=style&index=0&id=4ae69f28&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae69f28"]])

export default __exports__